module.exports = __webpack_public_path__ + "img/bg_pop_signin.5dbba1ea.jpg";